import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RegisterDashboardComponent } from './components/register-dashboard/register-dashboard.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { ManagerDashboardComponent } from './components/manager-dashboard/manager-dashboard.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { AddUserTagComponent } from './components/add-user-tag/add-user-tag.component';
import { TakeAssessmentComponent } from './components/take-assessment/take-assessment.component';
import { HrDashboardComponent } from './components/hr-dashboard/hr-dashboard.component';
import { ViewProgressComponent } from './components/view-progress/view-progress.component';
import { HeaderComponent } from './components/header/header.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { AddTeamComponent } from './components/add-team/add-team.component';
import { FooterComponent } from './components/footer/footer.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { TeamUsersComponent } from './team-users/team-users.component';
import { PulseScoreWidgetComponent } from './components/hr-dashboard/pulse-score-widget/pulse-score-widget.component';
import { MonthlyOverviewWidgetComponent } from './components/hr-dashboard/monthly-overview-widget/monthly-overview-widget.component';
import { CriticalTeamsWidgetComponent } from './components/hr-dashboard/critical-teams-widget/critical-teams-widget.component';
import { RecommendationsWidgetComponent } from './components/hr-dashboard/recommendations-widget/recommendations-widget.component';
import { HierarchyComponent } from './components/hr-dashboard/hierarchy/hierarchy.component';
import { UserDetailComponent } from './components/hr-dashboard/user-detail/user-detail.component';
import { TenantHeaderInterceptor } from './core/tenant-header.interceptor';
import { UserProfileComponent } from './components/user-profile/user-profile.component';

@NgModule({
  declarations: [
    AppComponent,
    RegisterDashboardComponent,
    AddTeamComponent,
    AddUserComponent,
    LoginComponent,
    UserDashboardComponent,
    ManagerDashboardComponent,
    AddUserTagComponent,
    TakeAssessmentComponent,
    HrDashboardComponent,
    ViewProgressComponent,
    HeaderComponent,
    FooterComponent,
    UpdatePasswordComponent,
    TeamUsersComponent,
    PulseScoreWidgetComponent,
    MonthlyOverviewWidgetComponent,
    CriticalTeamsWidgetComponent,
    RecommendationsWidgetComponent,
    HierarchyComponent,
    UserDetailComponent,
    UserProfileComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    FormsModule,
    NgxChartsModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),  // Provide HttpClient with interceptors
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TenantHeaderInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
